import HrTermTypeForm from 'components/forms/hr/HrTermTypeForm';

/** Route entry for creating or editing an HR term type. */
export default function HrTermTypeFormPage() {
  return <HrTermTypeForm />;
}
